import { render, staticRenderFns } from "./SlidingPageWrapper.vue?vue&type=template&id=8079dc70"
import script from "./SlidingPageWrapper.vue?vue&type=script&lang=js"
export * from "./SlidingPageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports